import { AxiosResponse } from 'axios';
import { ReturnCodesEnum } from 'app/bff/enums/codes';
import { BaseReq, BaseResp, ReqHeader, SortPageReq } from 'app/bff/models/base';
import { StorageKeysEnum } from 'app/core/enums/storage';
import commonService from 'app/core/services/commonService';
import storageService from 'app/core/services/storageService';
import modalService from 'app/core/services/modalService';
import store from 'app/store';
import { resetMemberCacheAction } from 'app/store/common/actions';

/**
 * @description 組合 API 基本請求資料格式
 * @param reqHeader Request header
 * @param transReq Request arguments
 */
export const combineBaseReq = <T>(reqHeader: ReqHeader, transReq: T): BaseReq<T> => ({ reqHeader, transReq });

/**
 * @description 組合 API 排序請求資料格式
 * @param page 頁面數量
 * @param size 資料數量
 */
export const combineSortPageReq = (page: number, size: number): SortPageReq => ({ page, size });

/**
 * @description Check http-response
 * @param response use http-response
 * @param triggerAlert if true, trigger `sweet-alert` fire when response not success
 * @param customMessage show this custom message when response not success
 */
export const checkHttpResponse = (response: AxiosResponse<BaseResp<any>>, triggerAlert = true, customMessage = ''): boolean => {
  if (triggerAlert) {
    try {
      switch (response.data.respHeader.returnCode) {
        case ReturnCodesEnum.CodeSuccess:
          break;
        /** 說明：「會員即時檢核功能已關閉」，視為成功 (2024/01/15) */
        case ReturnCodesEnum.CodeCheckingMobileEmailClosed:
          break;
        // 非法的 Token
        case ReturnCodesEnum.CodeIllegalToken:
        case ReturnCodesEnum.IllegalToken:
        case ReturnCodesEnum.TokenError8015:
        case ReturnCodesEnum.TokenError8016:
        case ReturnCodesEnum.TokenError8017:
        case ReturnCodesEnum.TokenError8018:
          modalService.base('系統提醒', response.data.respHeader.returnMsg).then((result) => {
            if (result.value) {
              // 重新生成 Session Id
              commonService.generateSessionId(true);
              // 清除「會員主檔」和「Access Token」
              storageService.removeItem(StorageKeysEnum.Authorization);
              store.dispatch(resetMemberCacheAction()); // 若不清除會員資料，於重新整理後會陷入無窮提示(一直用過期的 token 呼叫 API)
              // 執行瀏覽器重新整理
              window.location.reload();
            }
          });
          break;
          // 參數格式錯誤
        case ReturnCodesEnum.CodeParamFormatError :
          modalService.base('系統提醒', `<p>${response.data.respHeader.returnMsg}</p>` +
            commonService.displayErrorMsg(response.data.transResp).reduce<string>((pre, item) => {
              return pre + `<p>${item}</p>`;
            }, ''));
          break;
        case ReturnCodesEnum.KeycloakValidError:
          modalService.base('系統提醒', '登入錯誤，帳號或是密碼錯誤');
          break;
        default:
          modalService.base('系統提醒', response.data.respHeader.returnMsg);
          break;
      }
    } catch {
      modalService.base('系統提醒', customMessage || '系統發生錯誤，請洽資訊人員處理。');
      return false;
    }
  }
  return (
    response.data.respHeader.returnCode === ReturnCodesEnum.CodeSuccess ||
    response.data.respHeader.returnCode === ReturnCodesEnum.CodeCheckingMobileEmailClosed ||
    response.data.respHeader.returnCode === ReturnCodesEnum.CodeDataError ||
    response.data.respHeader.returnCode === ReturnCodesEnum.CodeCreditCardAuthorizationFailure ||
    response.data.respHeader.returnCode === ReturnCodesEnum.CodeCreditCardCancelAuthorizationFailure ||
    response.data.respHeader.returnCode === ReturnCodesEnum.CodeUserNotEnable
  );
};
